import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import lodash from "lodash";
//outsource
import { Row, Col, Layout, Form, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { detailBranchSelector } from "../../store/branch/branch.selector";
import { getBranchByShopId } from "../../store/branch/branch.action";
import { snapIncome } from "../../store/income/income.action";
import { unSnapIncome } from "../../store/income/income.action";
import { snapCashupDetail } from "../../store/cashup/cashup.action";
import { unSnapCashup } from "../../store/cashup/cashup.action";
import { labelDateSelector } from "../../store/var/var.selector";
import { incomeSelector } from "../../store/income/income.selector";
import { allSelector } from "../../store/credit_notes/credit_notes.selector";
import { allRedeemNotesSelector } from "../../store/credit_redeem/credit_redeem.selector";
import { IoReturnUpBackOutline } from "react-icons/io5";
import { voucherDateSelector } from "../../store/voucher/voucher.selector";
import { voucherRedeemDateSelector } from "../../store/voucher/voucher.selector";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import CashupTop from "./component/cashup_top";
import IncomeByStaffDetail from "./component/income_by_staff_detail";
import IncomeReceivableDetail from "./component/income_receivables_detail";

//components

import "./style.css";
import { detailSelector } from "../../store/cashup/cashup.selector";
import { Loading } from "../../component/loading";
import { allDiscountSelector } from "../../store/discount/discount.selector";
import moment from "moment";
import { staffListSelector } from "../../store/staff/staff.selector";
import { incomeDetailSelector } from "../../store/income_detail/income_detail.selector";
import {
  snapIncomeDetailByDate,
  unSnapIncomeDetail,
} from "../../store/income_detail/income_detail.action";
import { getStaffsByIds } from "../../store/staff/staff.action";

import {
  snapMediaByBranchByDate,
  unSnapMedia,
} from "../../store/media/media.action";

const { Content } = Layout;

const CashupScreen = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const [form] = Form?.useForm();
  const navigate = useNavigate();
  const shopId = params?.shopId;

  // -------------------------- STATE --------------------------
  const [totalReceive, setTotalReceive] = useState(0);
  const [fileList, setFileList] = useState([]);
  const [block, setBlock] = useState(true);
  const [edit, setEdit] = useState(false);
  const [status, setStatus] = useState(null);

  const [lockedBy, setLockedBy] = useState(null);

  // loading data
  const [isIncome, setIsIncome] = useState(false);
  const [isCashup, setIsCashup] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailBranchSelector);
  const label = useSelector(labelDateSelector);

  const staffList = useSelector(staffListSelector);
  // neu incomeStaff data ton lai thi lay incomesStaff, khong ton tai thi lay incomeStaffDetail
  let incomes = useSelector(incomeSelector);
  const incomesDetail = useSelector(incomeDetailSelector);
  // console.log({ incomesDetail });
  const convertIncomes = converIncomes(incomesDetail, branch, label, staffList);
  incomes =
    incomesDetail && incomesDetail?.length > 0 ? convertIncomes : incomes;

  const creditNotes = useSelector(allSelector);
  const vouchersDate = useSelector(voucherDateSelector);
  const vouchersRedeem = useSelector(voucherRedeemDateSelector);
  const creditRedeems = useSelector(allRedeemNotesSelector);
  const cashupDetail = useSelector(detailSelector);
  const discountNotes = useSelector(allDiscountSelector);
  const staffs = incomes?.staffs || null;

  // console.log({ status });
  const totalVoucher = convertTotalVouchers(vouchersDate);
  const totalVoucherRedeem = convertTotalRedeem(vouchersRedeem);
  const totalRedeem = convertTotal(creditRedeems);
  const totalDiscount = convertDiscount(discountNotes);
  const totalNotes = convertTotal(creditNotes);
  const totalStaffs = renderSumIncome(staffs) || 0;
  const totalIncomeStaff = totalNotes + totalStaffs + totalVoucher;
  const totalIncomeReceive =
    totalRedeem + totalDiscount + totalReceive + totalVoucherRedeem;
  const differ = Math.abs(totalIncomeReceive - totalIncomeStaff);
  // -------------------------- FUNCTION --------------------------
  const resetAllFields = () => {
    form?.resetFields();
    form?.setFieldValue("evidences", []);
    setFileList([]);
    setTotalReceive(0);
    setBlock(false);
    setEdit(true);
    setStatus(null);
    setLockedBy(null);
  };

  const handleNavigate = () => {
    const href = `/report/cashup/list`;
    navigate(href);
  };

  // -------------------------- EFFECT --------------------------

  useEffect(() => {
    if (shopId) {
      dispatch(getBranchByShopId({ shopId }));
    }
  }, [dispatch, shopId]);

  useEffect(() => {
    if (label && branch) {
      // snap incomeStaffDetail
      setIsIncome(false);
      setIsCashup(false);
      dispatch(
        snapIncome({ date: label, branch: branch?.id }, (res) => {
          if (res) {
            setIsIncome(true);
          }
        })
      );
      // snap media
      dispatch(snapMediaByBranchByDate({ date: label, branch: branch?.id }));
      // snap cashup
      dispatch(
        snapCashupDetail({ date: label, branch: branch?.id }, (res) => {
          if (res) {
            let evidences = res?.evidences || [];
            form?.setFieldValue("evidences", evidences);
            setFileList(evidences);
            // let totalReceive = res?.totalReceive;
            // setTotalReceive(totalReceive);
            let status = res?.status;
            setStatus(status);
            form?.setFieldsValue(res);
            setBlock(status === "confirmed" ? true : false);
            setEdit(status === "confirmed" ? false : true);
            setLockedBy(res?.lockedBy);
            //
            setIsCashup(true);
          } else {
            resetAllFields();
          }
        })
      );
    }

    return () => {
      dispatch(unSnapIncome());
      dispatch(unSnapCashup());
      dispatch(unSnapMedia());
    };
  }, [dispatch, label, branch]);

  useEffect(() => {
    if (cashupDetail) {
      const totalReceive = cashupDetail.totalReceive;
      setTotalReceive(totalReceive);
    }
  }, [cashupDetail]);

  // get Staff info in coop
  useEffect(() => {
    if (branch) {
      const coop = branch?.coop;
      if (coop) {
        dispatch(
          getStaffsByIds({ ids: coop }, (res) => {
            if (res.status === 200) {
              //
            }
          })
        );
      }
    }
  }, [dispatch, branch]);

  //get data tu incomeStaffDetail
  useEffect(() => {
    const date = label;
    const branchId = branch?.id;
    if (date && branchId) {
      dispatch(snapIncomeDetailByDate({ date, branch: branchId }));
      return () => dispatch(unSnapIncomeDetail());
    }
  }, [dispatch, label, branch]);
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    // const disabled = !(isIncome && isCashup);
    const disabled = !(!!incomes && isCashup)
    // console.log({incomes, isCashup, disabled})
    return (
      <>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderBackBtn()}
        </Col>
        <Row gutter={[20, 20]} className="section-cashup">
          <Col xl={24} lg={24} md={24} xs={24}>
            <CashupTop
              edit={edit}
              block={block}
              differ={differ}
              status={status}
              totalReceive={totalReceive}
              totalNotes={totalNotes}
              totalRedeem={totalRedeem}
              totalDiscount={totalDiscount} // discount
              totalStaffs={totalStaffs}
              totalIncomeStaff={totalIncomeStaff}
              totalIncomeReceive={totalIncomeReceive}
              totalVoucher={totalVoucher}
              totalVoucherRedeem={totalVoucherRedeem}
              setEdit={setEdit}
              setBlock={setBlock}
              resetAllFields={resetAllFields}
              lockedBy={lockedBy}
              incomes={incomes}
              disabled={disabled}
            />
          </Col>
          {renderCashupDetail()}
        </Row>
      </>
    );
  };

  const renderCashupDetail = () => {
    return (
      <>
        <Col xl={12} lg={12} md={24} xs={24}>
          <IncomeByStaffDetail
            edit={edit}
            sumTotal={totalIncomeStaff}
            incomes={incomes}
          />
        </Col>
        <Col xl={12} lg={12} md={24} xs={24}>
          <IncomeReceivableDetail
            edit={edit}
            fileList={fileList}
            setFileList={setFileList}
            sumTotal={totalIncomeReceive}
            totalReceive={totalReceive}
            setTotalReceive={setTotalReceive}
          />
        </Col>
      </>
    );
  };

  const renderBackBtn = () => {
    return (
      <Row style={{ margin: "20px 0px" }}>
        <Col xl={12} lg={12} md={24} xs={24}></Col>
        <Col align="right" xl={12} lg={12} md={24} xs={24}>
          <Button
            onClick={handleNavigate}
            icon={
              <span className="anticon">
                <IoReturnUpBackOutline />
              </span>
            }
            type="link"
          >
            Return Cashup List
          </Button>
        </Col>
      </Row>
    );
  };

  const renderDialog = () => {
    return <></>;
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout style={{ position: "relative" }} className="full">
      <Content className="content">
        <Row align="center">
          <Col xl={20} lg={20} md={24} xs={24}>
            <Form form={form} autoComplete="off">
              {renderBody()}
            </Form>
          </Col>
        </Row>
      </Content>
      {renderDialog()}
      <LayoutFooter />
    </Layout>
  );
};

export default CashupScreen;

const renderSumIncome = (data) => {
  const totals = data?.map((item) => {
    const income = item?.income;
    const total = lodash.sumBy(income, (r) => r?.value) || 0;
    return total;
  });

  const sum = lodash.sum(totals);
  return sum;
};

const convertTotal = (arr) => {
  const notes = arr?.notes;
  return lodash.sumBy(notes, (n) => n?.value) || 0;
};

const convertTotalVouchers = (arr) => {
  const totalBalance = lodash.sumBy(arr, (n) => n?.balance) || 0;
  const totalSpent = lodash.sumBy(arr, (n) => n?.spent) || 0;
  const totalValue = totalBalance + totalSpent;

  return totalValue;
};

const convertTotalRedeem = (arr) => {
  return lodash.sumBy(arr, (n) => n?.amount) || 0;
};

const convertDiscount = (discountNotes) => {
  const notes = discountNotes?.notes || [];
  const jobDiscount = discountNotes?.jobs || [];
  const totalData = [...notes, ...jobDiscount];
  return lodash.sumBy(totalData, (n) => n?.value) || 0;
};

const converIncomes = (incomesDetail, branch, label, staffList) => {
  const branchId = branch?.id;
  const owner = branch?.owner;
  const date = label;
  const onDate = moment(date, "DD/MM/YYYY").toDate();
  const staffIds =
    incomesDetail?.length > 0 && incomesDetail?.map((item) => item?.userId);
  const uniqIds = lodash.uniq(staffIds);
  // console.log({uniqIds});
  const update = uniqIds?.map((userId) => {
    let income = incomesDetail?.filter((item) => item?.userId === userId);
    //get compact incomes
    income = income?.map((item) => {
      const value = item?.value;
      const incomeId = item?.id;
      return {
        value,
        incomeId,
      };
    });
    const userInfo = staffList?.find((user) => user?.id === userId);
    const fullName = `${userInfo?.firstName} ${userInfo?.lastName}`;
    return {
      userId: userId,
      income,
      fullName,
    };
  });
  const staffs = update;
  return {
    branch: branchId,
    owner,
    date,
    onDate,
    staffs,
  };
};
